import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostRecommendedActionTemplateByUrlRequest = {
    url: string
};

export type PostRecommendedActionTemplateByUrlResponse = {
    fieldCount: number
    url: string
};

export const postRecommendedActionTemplateByUrl =
    createPostEndpoint<PostRecommendedActionTemplateByUrlRequest, PostRecommendedActionTemplateByUrlResponse>(
	    (request) => request.url, { requestTransform: ({ url, ...rest }) => rest }
    );
